module.exports = "<div class=\"container mt-5\">\r\n  <div class=\"mt-5 align-self-center text-center\">\r\n    <div class=\"text-center\"><i class=\"fa fa-5x fa-file-text-o\"></i></div>\r\n    <h1 class=\"mt-2\">Oops! Form Not Found</h1>\r\n    <p class=\"mt-3\"> The form you are trying to find either doesn't exist or is not active/available at this moment.<br>Please make sure you\r\n      have the correct form url.</p>\r\n  </div>\r\n</div>\r\n"


//////////////////
// WEBPACK FOOTER
// D:/a/1/s/src/app/notfound/notfound.component.html
// module id = ../../../../../src/app/notfound/notfound.component.html
// module chunks = main